import React, { useContext, useEffect } from 'react'
import { useBooks } from '@hooks/useBooks'
import {
  CARD_SIZES,
  HEADING_TYPE,
  TEXT_SIZES,
  DIVIDER_SIZE,
  BOOK_LIST_TYPES,
  USER_ROLES,
} from '@helpers/constants'
import Text from '@components/Text'
import Loader from '@components/Loader'
import BookList from '@components/BookList'
import Heading from '@components/Heading'
import Divider from '@components/Divider'
import { useFilteredItems } from '@hooks/useFilteredItems'
import BooksSharedWithSchoolClassesList from '@components/BooksSharedWithSchoolClassesList'
import { AppContext } from '@state/context'
import { setFilteredItems } from '@state/actions/filtersActions'

const Books = () => {
  const [state, dispatch] = useContext(AppContext)
  const userRole = state?.app?.userRole
  const {
    userBooks,
    userCreatedBooks,
    userSavedBooks,
    error: booksError,
    isLoading,
  } = useBooks()

  const filteredUserBooks = useFilteredItems(userBooks)
  const filteredUserSavedBooks = useFilteredItems(userSavedBooks)
  const filteredUserCreatedBooks = useFilteredItems(userCreatedBooks)

  useEffect(() => {
    dispatch(
      setFilteredItems([
        ...userBooks,
        ...userSavedBooks,
        ...userCreatedBooks,
      ]
    ))
  }, [userBooks, userSavedBooks, userCreatedBooks])

  return (
    <div className={'flex flex-col items-center justify-center'}>
      {userRole !== USER_ROLES.ADMIN &&
        <>
          <Heading headingLevel={HEADING_TYPE.H1} size={TEXT_SIZES.XXLARGE}>
            Dokletböcker
          </Heading>

          <Divider size={DIVIDER_SIZE.SMALL} />

          {booksError && <Text>Någonting gick fel när vi skulle hämta böcker</Text>}
          {!isLoading && !filteredUserSavedBooks.length && (
            <Text>Kunde inte hitta några böcker</Text>
          )}
          {filteredUserSavedBooks && (
            <BookList
              type={BOOK_LIST_TYPES.DOKLET}
              gridCols={4}
              items={filteredUserSavedBooks}
              cardSize={CARD_SIZES.SMALL}
              rowLimit={2}
            />
          )}
          {isLoading && <Loader />}

          <Divider size={DIVIDER_SIZE.MEDIUM} />
        </>
      }

      {userRole !== USER_ROLES.ADMIN &&
        <>
          <Heading headingLevel={HEADING_TYPE.H1} size={TEXT_SIZES.XXLARGE}>
            Mina egna böcker
          </Heading>

          <Divider size={DIVIDER_SIZE.BASE} />
        </>
      }

      {booksError && <Text>Någonting gick fel när vi skulle hämta böcker</Text>}
      {!isLoading && !filteredUserCreatedBooks.length && (
        <Text>Kunde inte hitta några böcker</Text>
      )}
      {filteredUserCreatedBooks && (
        <BookList
          type={BOOK_LIST_TYPES.USER_CREATED}
          gridCols={4}
          items={filteredUserCreatedBooks}
          cardSize={CARD_SIZES.SMALL}
          rowLimit={userRole !== USER_ROLES.ADMIN ? 2 : false}
        />
      )}
      {isLoading && <Loader />}

      <Divider size={DIVIDER_SIZE.MEDIUM} />

      {userRole !== USER_ROLES.ADMIN &&
        <>
          <Heading headingLevel={HEADING_TYPE.H1} size={TEXT_SIZES.XXLARGE}>
            Delade med klasser
          </Heading>

          <Divider size={DIVIDER_SIZE.BASE} />

          {booksError && <Text>Någonting gick fel när vi skulle hämta böcker</Text>}
          {!isLoading && !filteredUserBooks.length && (
            <Text>Kunde inte hitta några böcker</Text>
          )}
          {filteredUserBooks && !isLoading && (
            <BooksSharedWithSchoolClassesList items={filteredUserBooks} />
          )}
          {isLoading && <Loader />}

          <Divider size={DIVIDER_SIZE.BASE} />
        </>
      }
    </div>
  )
}

export default Books
